import { AUTH_QUERY } from "graphqlQueries/auth";
import { authMapper } from "graphqlQueries/auth.map";

import useAuth from "hooks/useAuth";
import useExecuteMutation from "hooks/useExecuteMutation";

import { signInValidator } from "validators/signInValidator";

export default function useSignInForm() {
  const { signIn } = useAuth();
  const { executeMutation, loading } = useExecuteMutation(AUTH_QUERY, {
    fieldsWithPlaceForError: ["username", "password"],
  });
  const initialValues = {
    username: "",
    password: "",
  };

  const onSubmit = async (data, { setErrors }) => {
    const response = await executeMutation(data);
    if (response?.formErrors) {
      setErrors(response.formErrors);
      return;
    }
    signIn(authMapper(response));
  };

  return { initialValues, loading, onSubmit, signInValidator };
}
